
export const MAX_RETRIES = 3;
export const WAIT_RETY_MS = 1 * 1000;
